/**
 * Only `isDebug` is consumed from here. The old `logo` / `projectName` keys
 * were a second, stale route to the same values and were never read — use
 * Config/AppLogo.js directly for branding.
 */
import { isDebug } from "./debug";

export const BasicInfo = {
  isDebug,
};
